import React, { useEffect, useState } from 'react';
import { Button, message, Modal, Empty, Radio, Spin, Cascader, Tag } from 'antd';
import 'moment/locale/zh-cn';
import { fetchClassifyAuditDetail, checkClassifyAuditPassImg, fetchClassifyInfo, classifyAuditTag } from '../../../../api/inspiration';
import WaterFall from '../../../../component/WaterFall';
import './index.less';

const getUsername = () => {
    return localStorage.getItem('username');
};

export default React.memo(function AuditModal(props) {
    const { visible, groupItem, setVisible, onUpdate, isCheck } = props;
    const [isLoading, setLoading] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [detailList, setDetailList] = useState([]);
    const [crawlWord, setCrawlWord] = useState('');
    const [selectedIds, setSelectedIds] = useState([]);
    const [tipVisible, setTipVisible] = useState(false);
    const [isAllSelected, setAllSelected] = useState(false);
    const [classifyOptions, setClassifyOptions] = useState([]);
    const [attrOptions, setAttrOptions] = useState([]);
    const [classifyLoading, setClassifyLoading] = useState(false);
    const [classifyValue, setClassifyValue] = useState([]);
    const [attrValues, setAttrValues] = useState([]);

    useEffect(() => {
        if (groupItem && visible) {
            setClassifyValue([]);
            setAttrValues([]);
            setSelectedIds([]);
            setDetailList([]);
            setClassifyOptions([]);
            getImgAuditDetail();
        }
    }, [groupItem, visible]);

    useEffect(() => {
        if (selectedIds.length != 0 && detailList.length != 0 && selectedIds.length == detailList.length && !isAllSelected) {
            setAllSelected(true);
        } else if ((selectedIds.length != detailList.length || selectedIds.length == 0 || detailList.length == 0) && isAllSelected) {
            setAllSelected(false);
        }
    }, [selectedIds]);

    const getImgAuditDetail = async () => {
        if (isLoading) return;
        setLoading(true);
        if (isCheck) {
            const res = await checkClassifyAuditPassImg({groupId: groupItem.id});
            if (res?.error?.code == 0 && res.data?.list) {
                setDetailList(res.data.list ?? []);
            } else {
                setDetailList([]);
            }
        } else {
            const res = await fetchClassifyAuditDetail({groupId: groupItem.id}, getUsername());
            if (res?.error?.code == 0 && res.data) {
                setCrawlWord(res.data.crawlWord ?? '');
                setDetailList(res.data.list ?? []);
                getClassifyInfo(res.data.crawlWord ?? '', true);
            } else {
                setCrawlWord('');
                setDetailList([]);
            }
        }       

        setLoading(false);
    };

    async function getClassifyInfo(searchWord, isFirst) {
        if (classifyLoading) {
            message.error('正在加载中，请勿频繁点击');
            return;
        }
        setClassifyLoading(true);
        const res = await fetchClassifyInfo({
            searchWord,
            first: isFirst
        });
        if (res?.error?.code == 0 && res.data) {
            if (isFirst) setClassifyOptions(res.data.classifyInfos ?? []);
            setAttrOptions(!isFirst && res.data.attrInfos ? res.data.attrInfos : []);
        } else {
            setClassifyOptions([]);
            setAttrOptions([]);
        }
        setClassifyLoading(false);
    }

    const allSelect = () => {
        if (isAllSelected) { // 取消全选
            setSelectedIds([]);
        } else { // 全选
            const selectList = detailList.map(v => v.id);
            setSelectedIds([...selectList]);
            const list = detailList.filter(v => v.classifyValue?.length > 0);
            if (list.length == 1) { // 只选中一张图片时
                if (classifyValue.length > 0 && classifyValue[classifyValue.length - 1] == list[0].classifyValue[list[0].classifyValue.length - 1]) {
                    setAttrValues([...list[0].attrValues]);
                } else { // 分类不一致，展示该图片的分类词
                    setClassifyValue([...list[0].classifyValue]);
                    setAttrValues([...list[0].attrValues]);
                    getClassifyInfo(list[0].classifyValue[list[0].classifyValue.length], false);
                }
            } else if (list.length > 1) {
                setClassifyValue([]);
                setAttrValues([]);
                setAttrOptions([]);
            }
        }
        
        setAllSelected(!isAllSelected);
    };

    const showConfirm = () => {
        setTipVisible(true);
    };

    // 提交入库
    const toPass = async () => {
        if (!tipVisible && confirmLoading) return;
        setConfirmLoading(true);

        // 筛选出所有已打标图片
        let list = detailList.filter(v => v.classifyValue?.length > 0).map(v => {
            // if (v.classifyValue && v.classifyValue.length > 0) {
            //     return ({
            //         attrWords: v.attrValues?.length > 0 ? v.attrValues.map(el => el.value[el.value.length - 1]) : [],
            //         classifyWord: v.classifyValue[v.classifyValue.length - 1] ?? '',
            //         id: v.id,
            //         insId: v.insId
            //     })
            // } else {
                return ({
                    attrWords: v.attrValues?.length == 0 ? v.attrList? v.attrList : v.attrValues.map(el => el.value[el.value.length - 1]) : [],
                    classifyWord: v.classifyValue[v.classifyValue.length - 1] ?? '',
                    id: v.id,
                    insId: v.insId
                })
            // }
            
        });

        // 通过审核
        const res = await classifyAuditTag({
            groupId: groupItem?.id,
            crawlWord,
            // 未打标图片
            delList: detailList.filter(v => list.findIndex(el => el.id == v.id) < 0).map(v => ({
                id: v.id,
                insId: v.insId
            })),
            list
        }, getUsername());
        if (res?.error?.code == 0 && res.data) {
            message.success('入库成功');
            setSelectedIds([]);
            setDetailList([]);
            setVisible(false);
            onUpdate(true);
        } else if (res?.error?.message) {
            message.error(res.error.message);
        } else {
            message.error('入库失败');
        }
        setTipVisible(false);
        setConfirmLoading(false);
    }
    
    // 分类选择
    function onClassifyInfoChange(value) {
        if (value.length > 0) {
            setClassifyValue(value);
            setAttrValues([]);
            getClassifyInfo(value[value.length -1], false);
        } else {
            setClassifyValue([]);
            setAttrOptions([]);
            setAttrValues([]);
        }        
    }

    // 属性选择
    const onAttrInfoChange = (v, l) => {
        console.debug(191, v, l)
        let i = attrValues.findIndex(value => value.label == l);
        console.debug(i)
        if (v.length <= 0) {
            if (i >= 0) {
                attrValues.splice(i, 1);
            }
        } else {
            if (i >= 0) {
                attrValues[i] = {
                    ...attrValues[i],
                    value: [...v]
                };
            } else {
                if (!attrValues) {
                    attrValues = []
                }
                attrValues.push({
                    label: l,
                    value: [...v]
                });
            }
        }

        setAttrValues([...attrValues]);
    }

    function classifyFilter(inputValue, path) {
        // 只匹配最后一项
        return path[path.length - 1].children.length <= 0 && path[path.length - 1].label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
    }

    // 打标
    function setTags() {
        if (classifyValue.length <= 0) {
            message.error('请先选择分类');
            return;
        }

        for (let i = selectedIds.length; i--;) {
            let _index = detailList.findIndex(value => value.id == selectedIds[i]);
            // 给图片添加属性词和分类词
            detailList[_index].classifyValue = [...classifyValue];
            detailList[_index].attrValues = [...attrValues];
        }

        setDetailList([...detailList]);
        setSelectedIds([]);
    }

    function displayWaterFallRender(v) {
        if (v.attrList) {
            return (
                <div className='waterfall_tags_wrap'>
                    {
                        v.classifyValue?.length > 0 && 
                        <Tag closable onClose={() => { // 第一个标签是分类词
                            let _index = detailList.findIndex(value => value.id == v.id);
                            // 删除分类词
                            detailList[_index].classifyValue = [];
                            // 删除分类词的同时也删除所有的属性词
                            detailList[_index].attrValues = [];
                            setDetailList([...detailList]);
                        }}>
                            {v.classifyValue[v.classifyValue.length - 1]}
                        </Tag>
                    }
                    {
                        v.attrList.map((item,index) => 
                            <Tag visible={true} key={index} closable onClose={async () => { // 其余标签是属性词
                                let _index = detailList.findIndex(value => value.id == v.id);
                                // 删除属性词
                                detailList[_index].attrList = detailList[_index].attrList.filter(v => v != item)
                                setDetailList([...detailList]);
                            }}>
                                {item}
                            </Tag>)
                    }
                    
                </div>
            )
        } else {
            return (
                <div className='waterfall_tags_wrap'>
                    {
                        isCheck ? v.tagList?.map((item, i) => <Tag key={i}>{item}</Tag>) :
                            (v.classifyValue?.length > 0 && (
                                <>
                                    <Tag closable onClose={() => { // 第一个标签是分类词
                                        let _index = detailList.findIndex(value => value.id == v.id);
                                        // 删除分类词
                                        detailList[_index].classifyValue = [];
                                        // 删除分类词的同时也删除所有的属性词
                                        detailList[_index].attrValues = [];
                                        setDetailList([...detailList]);
                                    }}>
                                        {v.classifyValue[v.classifyValue.length - 1]}
                                    </Tag>
                                    {
                                        v.attrValues?.map(item => item.value && <Tag key={item.label} closable onClose={() => { // 其余标签是属性词
                                            let _index = detailList.findIndex(value => value.id == v.id);
                                            // 删除属性词
                                            detailList[_index].attrValues.splice(detailList[_index].attrValues.findIndex(el => el.label == item.label), 1);
                                            setDetailList([...detailList]);
                                        }}>{item.value[item.value.length - 1]}</Tag>)
                                    }
                                </>
                            )
                        )
                    }
                </div>
            )
        };
    }

    /**
     * @param {*} v 图片信息
     * @param {*} isSelect 是否选中
     */
    function onImgSelect(v, isSelect) {
        if (isSelect && v.classifyValue?.length > 0) { // 有分类词
            if (selectedIds.length > 0) {
                if (classifyValue.length > 0 && classifyValue[classifyValue.length - 1] == v.classifyValue[v.classifyValue.length -1]) {
                    setAttrValues([]);
                } else if (classifyValue.length <= 0) {
                    setClassifyValue([...v.classifyValue]);
                    getClassifyInfo(v.classifyValue[v.classifyValue.length - 1], false);
                } else {
                    setClassifyValue([]);
                    setAttrValues([]);
                    setAttrOptions([]);
                }
            } else {
                if (classifyValue.length > 0 && classifyValue[classifyValue.length - 1] == v.classifyValue[v.classifyValue.length -1]) {
                    setAttrValues([...v.attrValues]);
                } else {
                    setClassifyValue([...v.classifyValue]);
                    setAttrValues([...v.attrValues]);
                    getClassifyInfo(v.classifyValue[v.classifyValue.length - 1], false);
                }
            }
        }
    }

    return (
      <Modal className='classifyAudit_modal' visible={visible} width={1550} onCancel={() => setVisible(false)} footer={null}>
        <div className='classifyAudit_modal_body'>
            <Spin spinning={isLoading}>
                {
                    !isCheck && (
                        <>
                            <div className='header'>
                                <div className='searchWord_wrap'>图片搜索词：{crawlWord ? <div className='searchWord'>{crawlWord}</div> : '暂无' }</div>
                                <div className='tail_container'>
                                    <div className='selected_count'>
                                        未打标<span>{detailList.length - detailList.filter(v => v.classifyValue?.length > 0).length}</span>张
                                    </div>
                                    <div className='radio_wrap' onClick={allSelect}>
                                        <Radio checked={isAllSelected}></Radio>
                                        全选当页
                                    </div>
                                    <Button
                                        type="primary"
                                        icon="check-circle"
                                        onClick={showConfirm}
                                        loading={confirmLoading}
                                        style={{marginRight: 10}}
                                    >
                                        提交入库
                                    </Button>
                                </div>
                            </div>
                            <Spin spinning={classifyLoading}>
                                <div className='classify_wrap'>
                                    <div className='classify_item'>
                                        分类：
                                        <Cascader value={classifyValue} showSearch={{matchInputWidth: false, filter: classifyFilter}} style={{width: 100}} options={classifyOptions}
                                         onChange={onClassifyInfoChange} displayRender={l => l[l.length - 1]} placeholder='选择分类' expandTrigger='hover' />
                                    </div>
                                    {
                                        attrOptions.map((v, i) => (
                                            <div className='classify_item' key={i}>
                                                {v.label ?? ''}：
                                                <Cascader showSearch={{matchInputWidth: false}} options={v.children ?? []} placeholder='请选择' style={{width: 100}}
                                                 value={attrValues.find(el => el.label == v.label)?.value ?? []}
                                                 onChange={j => onAttrInfoChange(j, v.label)} displayRender={l => l[l.length - 1]} expandTrigger='hover' changeOnSelect />
                                            </div>
                                        ))
                                    }
                                    {
                                        classifyValue.length > 0 && <Button disabled={selectedIds.length <= 0} shape="circle" icon="check" type='primary' onClick={setTags} />
                                    }
                                </div>
                            </Spin>
                        </>
                    )
                }

                <div className='main'>
                    <div className='imgs_wrap'>
                        <WaterFall
                            list={detailList}
                            selectedIds={selectedIds}
                            setSelectedIds={isCheck ? null : setSelectedIds}
                            displayRender={displayWaterFallRender}
                            onSelect={onImgSelect}
                            disabled={classifyLoading}
                        />
                    </div>
                </div>
                
                {
                    !isLoading && detailList.length <= 0 && <Empty description='暂无图片' />
                }
            </Spin>

            <Modal
                title="提示"
                visible={tipVisible}
                onOk={toPass}
                confirmLoading={confirmLoading}
                onCancel={() => setTipVisible(false)}
                maskClosable={false}
                okText='确认'
                cancelText='取消'
                >
                <p>点击确认后即审核通过选中的图片，是否确认？</p>
            </Modal>
        </div>
      </Modal>
    )
        
})